import { useEnvironment } from 'contexts/UserEnvironmentContext';
import { useSearchLocation } from 'modules/search/contexts/SearchContext';

export function useSearchReady() {
  const { environment } = useEnvironment();

  const searchLocation = useSearchLocation();

  const mainSearchReady = Boolean(environment) && Boolean(searchLocation);

  return { mainSearchReady };
}
